export const FROM_HC = 'FROM_HC';
export const SET_TEMPLATE_BUILDER_TEMPLATE = 'SET_TEMPLATE_BUILDER_TEMPLATE';
export const SET_TEMPLATE_EDITOR_STATE = 'SET_TEMPLATE_EDITOR_STATE';
export const SET_TEMPLATE_FIELD = 'SET_TEMPLATE_FIELD';
export const SET_TEMPLATE_HIRING_CLIENT = 'SET_TEMPLATE_HIRING_CLIENT';

export const SET_COMM_PLACEHOLDERS = 'SET_COMM_PLACEHOLDERS';

export const SET_SAVING_TEMPLATE = 'SET_SAVING_TEMPLATE';
export const SET_TEMPLATE_ERROR_MSG = 'SET_TEMPLATE_ERROR_MSG';
export const SET_TEMPLATE_SUCCESS_MSG = 'SET_TEMPLATE_SUCCESS_MSG';
